// Service worker registration for the installable (PWA) build.
//
// Only runs in production builds: the CRA dev server rebuilds on every save,
// and a worker caching those assets makes local development lie to you.
// Registration is skipped silently when the browser has no support, so the
// app behaves exactly as before on anything that cannot install it.

const SW_URL = `${process.env.PUBLIC_URL}/sw.js`;

// Fired when a new build has been downloaded and is waiting to take over.
// UpdateBanner listens for it; the detail is the ServiceWorkerRegistration.
export const SW_UPDATE_EVENT = 'ld:sw-update';

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_URL)
      .then((registration) => {
        if (registration.waiting && navigator.serviceWorker.controller) {
          announceUpdate(registration);
        }
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            // `controller` is null on the very first install — that is a
            // fresh cache being filled, not an update to offer.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              announceUpdate(registration);
            }
          });
        });
      })
      .catch((error) => {
        console.warn('Service worker registration failed:', error);
      });
  });
}

function announceUpdate(registration) {
  window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT, { detail: registration }));
}

// Hand the waiting worker control and reload once it has it. Guarded because
// `controllerchange` also fires on the first install in other tabs.
export function applyUpdate(registration) {
  if (!registration || !registration.waiting) {
    window.location.reload();
    return;
  }
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
}

export default registerServiceWorker;
